import ApiForm from 'src/pages/Api/ApiForm.vue'
import Index from 'src/pages/Api/Index.vue'

export default {
  path: 'api',
  component: Index,
  children: [
    {
      path: '',
      name: 'api.index',
      component: ApiForm,
      meta: {
        title: 'Api',
        requireAuth: true
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/api.js